// http://localhost:8080/conteudo/listarCalendario?codTipoPublicacao=1&datDespublicar=false&datFinal=2025-01-31&datInicial=2025-01-01&datPublicar=true

import { api } from './';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const obterCalendario = async (datInicial: string, datFinal: string) => {
  try {
    const response = await api.get(
      `/conteudo/listarCalendario?&datDespublicar=false&datFinal=${datFinal}&datInicial=${datInicial}&datPublicar=true`
    );
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter calendário';
    throw new Error(errorMessage);
  }
};

